import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { LocalizationModule } from "@webapp/localization/localization.module";
import { ErrorNotificationModule } from "@webapp/shared/error-notification/error-notification.module";
import { TagSelectorComponent } from "@webapp/tags/components/tag-selector/tag-selector.component";
import { UiIconModule } from "@webapp/ui/icon/icon.module";
import { UiSelectModule } from "@webapp/ui/select/select.module";
import { TagServiceProvider } from "./providers/tag-service.provider";

@NgModule({
  imports: [UiSelectModule, UiIconModule, LocalizationModule, FormsModule, ErrorNotificationModule, CommonModule],
  providers: [TagServiceProvider],
  declarations: [TagSelectorComponent],
})
export class TagsCoreModule {}
